import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;
  height: 100%;
  gap: 20px;
  padding: 0 20px 30px 20px;

  .action {
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0 0px;
    align-items: center;

    .action-double {
      display: flex;
      align-items: center;
      padding: 10px;
      border-radius: 10px;
      flex-wrap: wrap;
      margin-left: 20;
      width: 100%;
      gap: 20px;

      @media (max-width: 768px) {
        width: 100%;
      }
    }

    .action-buttons {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;
    }

    .export-excel {
      border-radius: 50px;
      padding: 0 20px;
      height: 50px;
      display: flex;
      align-items: center;
      gap: 8px;
      border: none;
      cursor: pointer;
      justify-content: center;
      font-weight: 700;
      font-size: 13px;
      color: #ffffff;
      font-family: 'Montserrat', sans-serif;
      background: #107c41;
      box-shadow: 0 4px 12px rgba(16, 124, 65, 0.25);
      transition: all 0.2s ease;

      &:hover {
        background: #0d6535;
        box-shadow: 0 6px 16px rgba(16, 124, 65, 0.35);
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(0);
      }
    }

    .justify {
      border-radius: 50px;
      width: 140px;
      display: flex;
      height: 50px;
      align-items: center;
      border: none;
      cursor: pointer;
      justify-content: center;
      font-weight: 700;
      color: #ffffff;
      font-family: 'Montserrat', sans-serif;
      background: #002266;
      box-shadow: 0 4px 12px rgba(0, 34, 102, 0.25);
      transition: all 0.2s ease;

      &:hover {
        background: #001842;
        transform: translateY(-1px);
      }
    }

    .restart {
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: 500px;
      border: none;
      background-color: #00205b;
      cursor: pointer;

      &:hover {
        animation: roll 400ms;
      }
    }
  }

  .react-calendar {
    width: 350px;
    position: absolute;
    left: 0;
    bottom: -100px;
    max-width: 100%;
    padding: 10px 20px;
    background: white;
    border: none;
    border-radius: 27px;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    line-height: 1.125em;
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    height: 44px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__navigation button[disabled] {
    background-color: #f0f0f0;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: capitalize;
    font-weight: bold;
    font-size: 0.75em;
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekNumbers {
    font-weight: bold;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
  }
  .react-calendar__month-view__days__day--weekend {
    color: #d10000;
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  .react-calendar__tile {
    max-width: 100%;
    text-align: center;
    padding: 0;
    background: none;
    width: 10px;
    height: 50px;
  }
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: #002b80;
    color: #ffffff;
    border-radius: 500px;
  }
  .react-calendar__tile--now {
    background: #100797ff;
    color: #ffffff;
    border-radius: 500px;
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #1509b8ff;
    border-radius: 500px;
  }
  .react-calendar__tile--hasActive {
    background: #76baff;
    border-radius: 500px;
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: #a9d4ff;
    border-radius: 500px;
  }
  .react-calendar__tile--active {
    background: #006edc;
    color: white;
    border-radius: 500px;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: #1087ff;
    border-radius: 500px;
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
    border-radius: 500px;
  }
`
export const ModalTextContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;

  .icon-calendar {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    background: #312780;
    border: none;
    border-radius: 50px;
    padding: 10px;
    width: 100px;
    cursor: pointer;
    height: 40px;

    p {
      font-size: 11px;
      top: 13px;
    }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 800;
    color: #ffffff;
    font-family: 'Montserrat', sans-serif;
    height: 50px;
    padding: 20px;
    border-radius: 27px 27px 0 0;
    background: #002b80;
    z-index: 2000;
  }

  .content-modal {
    background: rgb(0, 24, 66);
    z-index: 10000;
    border-radius: 0 0 27px 27px;
    padding: 10px 20px 0 20px;
    font-family: 'Montserrat', sans-serif;

    .header-content {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
      font-style: italic;
      font-size: 16px;
      color: #ffffff;
    }

    p {
      color: #ffffff;
      font-weight: 600;
    }

    .context {
      padding: 20px 0 0 0;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .dist {
        display: flex;
        flex-direction: column;
        gap: 10px;
        select {
          height: 50px;
          width: 100%;
        }
      }

      .about {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;

        select {
          height: 50px;
          width: 100%;
        }
      }

      .obs {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
        textarea {
          height: 100px;
          width: 100%;
          padding: 10px;
          color: #000;
        }
      }

      .button {
        display: flex;
        justify-content: end;
        margin: 0 0 20px 0;
        gap: 20px;

        button {
          height: 40px;
          width: 120px;
          border: none;
          font-family: 'Montserrat', sans-serif;
          border-radius: 32px;
          color: #ffffff;
          font-weight: 600;
          font-size: 16px;
          box-shadow: 0 4px 10px 1px rgba(0, 0, 0, 0.1);

          &:nth-child(1) {
            background-color: #990000;
          }

          &:nth-child(2) {
            background-color: #274e13;
          }
        }
      }
    }

    textarea {
      resize: none;
      width: 100%;
      height: 30px;
      border-radius: 20px;
      border: none;
      box-shadow: 0 4px 10px 1px rgba(0, 0, 0, 0.1);
      font-family: 'Montserrat', sans-serif;
      padding: 6px 10px 0 10px;

      &:focus {
        outline: none;
      }
    }

    select {
      width: 100%;
      border-radius: 20px;
      background: linear-gradient(to right, #efefef, #f4f4f4);
      height: 30px;
      padding: 0 20px;
      border: none;
      box-shadow: 0 4px 10px 1px rgba(0, 0, 0, 0.1);
      font-family: 'Montserrat', sans-serif;

      &:focus {
        outline: none;
      }
    }
  }
`
export const Modal = styled.div`
  position: absolute;
  width: 100vw;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 30000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);

  .content {
    position: relative;
    width: 50%;
    padding: 0 0 0 20px;

    .logout {
      background-color: #002b80;
      border-radius: 500px;
      color: #ffffff;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      cursor: pointer;
      right: 20px;
      border: none;
      top: 30px;
      z-index: 500000;
      font-family: 'Montserrat', sans-serif;
    }

    .header {
      position: absolute;
      top: 0;
      background: linear-gradient(to right, #001842, #00205b, #002b80);
      width: 100%;
      left: 0;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      border-radius: 0 27px 0 27px;
      font-size: 18px;
      font-weight: 700;
      font-family: 'Montserrat', sans-serif;
      text-transform: uppercase;
    }

    .resume {
      border-radius: 27px;
      display: flex;
      gap: 20px;
      flex-direction: column;
      padding: 50px 20px;
      background-color: #ffffffff;
      height: 100%;
      border-radius: 0 27px 27px 27px;

      .resume-content {
        display: flex;
        gap: 10px;
        flex-direction: column;
        h3 {
          width: 100%;
          text-align: center;
        }
      }
    }

    .buttons {
      display: flex;
      gap: 20px;
      margin-top: 10px;
      width: 100%;
      justify-content: center;

      button,
      label {
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        border-radius: 27px;
        cursor: pointer;
        font-family: 'Montserrat', sans-serif;
        font-size: 12px;
        font-weight: 700;
        color: #ffffff;
        text-transform: uppercase;
      }

      .cancel {
        background-color: #990000;
      }

      .edit {
        background-color: #00205b;
      }

      .ok {
        transition: all ease-in-out 400ms;
        background-color: #274e13;
        &:disabled {
          background-color: #7e7e7e93;
          transition: all ease-in-out 1s;
        }
      }
    }
  }
`

export const ModalContent = styled.div`
  width: 50%;
  height: 50%;
  animation: showModal 1s;

  @keyframes showModal {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const ModalClose = styled.div`
  width: 100%;
`

export const ModalAdmStyle = styled.div`
  width: 90%;
  height: 80%;
  margin-top: 120px;

  select {
    height: 40px;
    border: none;
    border-radius: 27px;
    width: 427px;
    padding: 0 10px;
    box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);

    &:focus {
      outline: none;
    }
  }

  input {
    height: 40px;
    border: none;
    border-radius: 27px;
    width: 427px;
    padding: 0 10px;
    box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);

    &:focus {
      outline: none;
    }
  }

  button {
    background: linear-gradient(to right, #001842ff, #00205b, #002b80);
    box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);
    color: #ffffff;
    border-radius: 27px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 16px;
    border: none;
    width: 130px;
    cursor: pointer;
    height: 40px;
  }

  .header {
    background: linear-gradient(to right, #001842ff, #00205b, #002b80);
    width: 100%;
    height: 48px;
    border-radius: 0px 27px 0 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: #ffffff;
    position: absolute;
    top: 0px;
  }

  .content {
    height: 90%;
    position: relative;

    .camp {
      font-size: 16px;
      font-weight: 600;
      font-family: 'Montserrat', sans-serif;
      width: 99%;
      margin-left: 16px;
      background: ${(props) => props.theme.background};
      border-radius: 0 0 27px 27px;
      box-shadow: 0px 2px 30px 1px rgba(0, 0, 0, 0.2);
      margin-top: 30px;
      height: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #001f5b;
      justify-content: center;
      gap: 10px;

      .cod {
        input {
          text-align: center;
          width: 60px;
        }
      }

      .name {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60%;
        gap: 20px;

        .photo {
          width: 130px;
          height: 130px;
          font-size: 15px;
          font-weight: 600;
          background-color: #00246b3a;
          color: #001f5b;
          border-radius: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
        }
      }

      .solo {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 0 8px;
        flex-direction: column;
      }
    }
  }

  .logout {
    background-color: #2a365e;
    border-radius: 500px;
    color: #ffffff;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    cursor: pointer;
    right: 20px;
    top: 20px;
    font-family: 'Montserrat', sans-serif;
  }
`

export const TitleGroup = styled.div`
  border-left: 4px solid #a6c10b;
  padding-left: 15px;
  font-family: 'Montserrat', sans-serif;
  h2 {
    color: ${(props) => props.theme.titleColor};
    font-size: 26px;
    letter-spacing: -0.5px;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
  p {
    color: ${(props) => props.theme.subtitleColor};
    font-size: 13px;
    opacity: 0.9;
  }
`
